<template>
  <div
    :class="!ativoComp ? 'ui-select inativo' : destaque ? 'ui-select destaque' : 'ui-select'"
    @mouseleave="fecharDropDown"
  >
    <img v-if="icone" class="icone" :src="require(`@/assets/vivo-consulta/icones/${icone}`)" />
    <img
      class="seta"
      :style="showOptionsComp ? 'transform: translate(0, -50%) scaleY(-1)' : ''"
      src="@/assets/vivo-consulta/icones/seta-input.png"
    />
    <span
      :style="icone ? 'padding-left: 30px' : 'padding-left: 10px'"
      :class="destaque ? 'roxo' : ''"
      @click="dropDown"
      >{{ valorComp }}</span
    >
    <ul class="opcoes" v-if="showOptionsComp">
      <li
        v-for="(option, index) in options"
        class="opcao"
        :key="index"
        @click="selecionarOpcao(option)"
      >
        {{ option }}
        <br />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'UiSelect',

  props: {
    ativo: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: 'Placeholder',
    },
    icone: {
      type: String,
    },
    options: {
      type: Array,
      default: () => ['Escolha uma opção'],
    },
    destaque: {
      type: Boolean,
    },
  },

  data() {
    return {
      valor: undefined,
      showOptions: false,
    };
  },

  computed: {
    ativoComp() {
      return this.ativo;
    },
    showOptionsComp() {
      return this.showOptions;
    },
    valorComp() {
      return this.valor == undefined ? this.placeholder : this.valor;
    },
  },

  methods: {
    selecionarOpcao(opcao) {
      this.valor = opcao;
      this.fecharDropDown();
    },
    dropDown() {
      this.ativo ? (this.showOptions = !this.showOptions) : null;
    },
    fecharDropDown() {
      this.showOptions = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.ui-select {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  border-radius: 5px;
  border: 1px solid $cor_cinza_medium;
  height: 40px;
  width: 100%;
  transition: all 0.2s ease-in-out;
  z-index: 1;

  & img {
    user-select: none;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }

  & .icone {
    left: 10px;
    max-width: 15px;
    height: auto;
    opacity: 0.5;
  }

  & .seta {
    right: 10px;
    max-width: 18px;
    height: auto;
    opacity: 0.5;
    transition: all 0.2s ease-in-out;
  }

  & span {
    cursor: pointer;
      font-family: 'VivoType';
    font-weight: bold;
    font-size: 14px;
    line-height: 40px;
    width: 100%;
  }

  & .roxo {
    font-weight: bold;
    color: $cor_roxo;
  }

  & ul {
    position: absolute;
    top: 41px;
    left: -1px;
    width: calc(100% - 20px);
    border: 1px solid white;
    background: white;
    margin: 0px;
    padding: 10px 10px;
    border-radius: 5px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    max-height: 14vh;
    overflow-y: scroll;

    & li {
      cursor: pointer;
      user-select: none;
      font-size: 14px;
      padding: 5px 10px;
      border-radius: 80px;
      color: $cor_cinza_dark;

      &:hover {
        background: $cor_roxo;
        color: white;
      }
    }
  }

  &:hover {
    // border-radius: 5px 5px 0 0;
    background: $cor_roxo;

    & > img {
      filter: brightness(1) grayscale(1) invert(1);
    }

    & > span {
      color: white;
    }
  }
}

.inativo {
  border: 1px solid $cor_cinza_light;
  background: $cor_cinza_light;

  & img {
    filter: brightness(1) grayscale(1) invert(1);
  }

  & span {
    cursor: default !important;
    color: $cor_cinza_medium !important;
  }

  &:hover {
    background: $cor_cinza_light !important;
  }
}

.destaque {
  border: 1px solid $cor_roxo;
  box-shadow: inset 0px 0px 10px rgba(102, 0, 153, 0.25);
}
</style>
